var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgTrash = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 15,
    viewBox: "0 0 13 15",
    fill: "#808285",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 2.46094V1.64062C0 1.25098 0.310491 0.9375 0.696429 0.9375H3.94643L4.2192 0.389648C4.33527 0.149414 4.57612 0 4.84018 0H8.15692C8.42098 0 8.66183 0.149414 8.7808 0.389648L9.05357 0.9375H12.3036C12.6895 0.9375 13 1.25098 13 1.64062V2.46094C13 2.6543 12.8433 2.8125 12.6518 2.8125H0.348214C0.156696 2.8125 0 2.6543 0 2.46094ZM12.0714 4.10156V13.5938C12.0714 14.3701 11.4475 15 10.6786 15H2.32143C1.55246 15 0.928571 14.3701 0.928571 13.5938V4.10156C0.928571 3.9082 1.08527 3.75 1.27679 3.75H11.7232C11.9147 3.75 12.0714 3.9082 12.0714 4.10156ZM4.17857 6.09375C4.17857 5.83594 3.96964 5.625 3.71429 5.625C3.45893 5.625 3.25 5.83594 3.25 6.09375V12.6562C3.25 12.9141 3.45893 13.125 3.71429 13.125C3.96964 13.125 4.17857 12.9141 4.17857 12.6562V6.09375ZM6.96429 6.09375C6.96429 5.83594 6.75536 5.625 6.5 5.625C6.24464 5.625 6.03571 5.83594 6.03571 6.09375V12.6562C6.03571 12.9141 6.24464 13.125 6.5 13.125C6.75536 13.125 6.96429 12.9141 6.96429 12.6562V6.09375ZM9.75 6.09375C9.75 5.83594 9.54107 5.625 9.28571 5.625C9.03036 5.625 8.82143 5.83594 8.82143 6.09375V12.6562C8.82143 12.9141 9.03036 13.125 9.28571 13.125C9.54107 13.125 9.75 12.9141 9.75 12.6562V6.09375Z"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgTrash);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/Trash.f0796bb4461bd38c5c7737c8286ff649.svg";